import {
  EntitySection,
  RecentDocument,
  RequiredItem,
} from "v2/store/entityDocumentsApi";

export type RequiredSectionGroup = {
  section: EntitySection;
  items: RequiredItem[];
  uploaded: RecentDocument[];
};

export const SECTION_ORDER: EntitySection[] = [
  "About the company",
  "Books & financials",
  "Tax",
];

const EMPTY_UPLOADED: RecentDocument[] = [];

export const groupRequiredBySection = (
  items: RequiredItem[],
  uploaded: RecentDocument[] = EMPTY_UPLOADED
): RequiredSectionGroup[] =>
  SECTION_ORDER.map((section) => ({
    section,
    items: items
      .filter((item) => item.section === section)
      .sort((a, b) => Number(b.isUrgent) - Number(a.isUrgent)),
    uploaded: uploaded.filter((document) => document.section === section),
  })).filter((group) => group.items.length > 0 || group.uploaded.length > 0);
